<template>
  <div style="margin: 20px 20px 0 30px; display: flex; justify-content: flex-start;">
    <el-col :span="6">
      <el-card class="box-card">
        <div slot="header" style="height: 40px; display: flex; align-items: center;">
          <span>订单分类</span>
        </div>
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="ordertypedata">
          <el-table-column
            prop="id"
            width="50"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="typename"
            label="分类">
          </el-table-column>
          <el-table-column
            label="操作"
            width="50"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除分类">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="delordertype(scope.$index, ordertypedata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-left: 20px;">
      <el-card class="box-card">
        <div slot="header" style="height: 40px; display: flex; align-items: center;">
          <span>订单状态</span>
        </div>
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="orderstatedata">
          <el-table-column
            prop="id"
            width="50"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="state"
            label="描述">
          </el-table-column>
          <el-table-column
            label="操作"
            width="50"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除状态">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="delorderstate(scope.$index, orderstatedata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'OrderType',
  data () {
    return {
      ordertypedata: [],
      orderstatedata: []
    }
  },
  mounted: function () {
    that = this
    that.getorderstate()
    that.getordertype()
  },
  methods: {
    getordertype () {
      var qstr = "ownphone = '" + localStorage.getItem('username') + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryordertype',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.ordertypedata = res.data
          } else {
            that.ordertypedata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getorderstate () {
      var qstr = "ownphone = '" + localStorage.getItem('username') + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryorderstate',
        method: 'post',
        data: {
          whereinfo: qstr,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.orderstatedata = res.data
          } else {
            that.orderstatedata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delordertype(index,data) {
      var datatmp = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/delordertype',
        method: 'post',
        data: {
          id: datatmp.id.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.getordertype()
            that.$message({
              type: 'success',
              message: '已删除订单信息!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delorderstate (index,data) {
      var datatmp = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/delorderstate',
        method: 'post',
        data: {
          id: datatmp.id.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.getorderstate()
            that.$message({
              type: 'success',
              message: '已删除订单信息!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/order/OrderType.vue